/* eslint no-magic-numbers: 0 */
import MobileDetect from 'mobile-detect'

const mobileDetector = new MobileDetect(window.navigator.userAgent)

const detectWebView = () => {
  const isUIwebview = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(navigator.userAgent)

  if (isUIwebview) {
    return true
  } else {
    return false
  }
}

export default {
  md: mobileDetector,
  isMobile: !!mobileDetector.mobile(),
  isWebView: detectWebView(),
  LocalStorageKeys: {
    Authorization: 'Authorization',
    Credentials: 'credentials',
    Rooms: 'Rooms',
    Room: 'Room'
  },
  WeekDays: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday']
}



// WEBPACK FOOTER //
// ./src/config/index.js